<template>
  <v-container style="max-width: 1000px;">
    <v-layout wrap>
      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3 text-xs-center">
          History of changes
        </h1>
        <v-timeline dense clipped>
          <v-timeline-item color="red lighten-2" small>
            <v-card class="elevation-2">
              <v-card-title class="headline">Not yet filled.</v-card-title>
              <v-card-text>
              Work in progress...
              </v-card-text>
            </v-card>
          </v-timeline-item>
          <v-timeline-item color="red lighten-2">
            <v-card class="elevation-2">
              <v-card-title class="headline">Initial set of patches - November 23, 2018</v-card-title>
              <v-list>
                <template v-for="item in milestone1">
                  <v-list-tile :key="item.text" >
                    <!-- <v-list-tile-content> -->
                      <!-- <v-list-tile-title> -->
                        <v-chip v-if="item.oc" color="green darken-1" text-color="white" disabled>OC</v-chip>
                        <v-chip v-if="item.minor" color="grey darken-1" text-color="white" disabled>Minor</v-chip>
                        <v-chip v-if="item.wine" color="orange" text-color="white" disabled>Wine</v-chip>
                        <v-chip v-if="item.fix" color="red" text-color="white" disabled>Fix</v-chip>
                        <v-chip v-if="item.vista" color="primary" text-color="white" disabled>Vista</v-chip>
                        {{ item.text }}
                      <!-- </v-list-tile-title> -->
                    <!-- </v-list-tile-content> -->
                  </v-list-tile>
                </template>
              </v-list>
            </v-card>
          </v-timeline-item>
          <v-timeline-item color="teal lighten-2" small>
            <v-layout justify-space-between>
              <v-flex>The starting point of the project</v-flex>
              <v-flex text-xs-right>November 23, 2018</v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      milestone1: [
        { text: "Import Wine Threadpool API implementation", vista: true, wine: true },
        { text: "Stub NTDLL Unloaded modules API", vista: true, oc: true },
        { text: "Import Wine Event Provider API stubs", vista: true, wine: true },
        { text: "Import Wine KERNEL32 WER API stubs", vista: true, wine: true },
        { text: "Stub KERNEL32 GetNLSVersionEx", vista: true, oc: true },
        { text: "Implement KERNEL32 CreateMutexEx and CreateSemaphoreEx", vista: true, oc: true },
        { text: "Export already implemented COMCTL32 API", vista: true, minor: true },
        { text: "Export already implemented NTDLL API", vista: true, minor: true },
        { text: "Export already implemented KERNEL32 API", vista: true, minor: true },
        { text: "Implement many WTSAPI32.WTSQuerySessionInformation classes", vista: true, oc: true },
        { text: "Implement NtQuerySystemInformation class 80: System Memory Lists information", vista: true, oc: true },
        { text: "Implement PsGetPreviousProcess", vista: true, oc: true },
        { text: "Implement process creation kernel callback (PspOpenProcess)", vista: true, oc: true },
        { text: "Export already implemented NtQueueApcThreadEx syscall", vista: true, minor: true },
        { text: "Implement NtGetNextProcess syscall", vista: true, oc: true },
        { text: "Stubplement NtGetNextThread syscall", vista: true, oc: true },
        { text: "Fix wrong flag handling in COMCTL32 Toolbar widget", fix: true, oc: true },
        { text: "Fix typo in MiCheckForUserStackOverflow", fix: true, minor: true },
        { text: "Implement last stack page guard handling in MiCheckForUserStackOverflow", oc: true },
        { text: "Implement standby page lists usage (but no standby pages are created for now)", oc: true },
        { text: "Reimplement ObpIncrementHandleCount to use only ACCESS_MASK", vista: true, oc: true },
        { text: "Grant PROCESS_QUERY_LIMITED_INFORMATION when PROCESS_QUERY_INFORMATION is granted", vista: true, oc: true },
        { text: "Fix and implement missing Win32K WM_GETTEXTLENGTH, WM_GETTEXT and WM_SETTEXT", fix: true, oc: true },
        { text: "Use 2nd parameter for NtUserGetThreadDesktop (ignored till now)", fix: true, oc: true },
        { text: "NtUserGetThreadDesktop reliability fixes", fix: true, oc: true },
        { text: "NtUserGetGUIThreadInfo reliability fixes", fix: true, oc: true },
        { text: "Rework window background erasure in Win32K", fix: true, oc: true },
        { text: "Reduce amount of recursive repaint calls in Win32K", fix: true, oc: true },
        { text: "More informative CallWindowProc error logging", minor: true },
        { text: "Restore commented out code in TranslateMessage", fix: true, minor: true },
        { text: "Implement PROCESS_EXTENDED_BASIC_INFORMATION support in NtQueryInformationProcess", vista: true, oc: true },
        { text: "Reduce some token requirements to PROCESS_QUERY_LIMITED_INFORMATION in NtQueryInformationProcess", vista: true, oc: true },
        { text: "Implement NtQueueApcThreadEx syscall (by reusing NtQueueApcThread)", vista: true, oc: true },
        { text: "Implement RtlGetFullPathName_UEx", vista: true, oc: true },
        { text: "Allow reuse of SYSTEM_MEMORY_LIST_INFORMATION definition in kernel code", minor: true },
        { text: "Fix memory access violation in WriteConsole (parameter is optional)", vista: true, oc: true, fix: true },
        { text: "Partial sync of NLS in KERNEL32 with latest Wine", vista: true, wine: true },
        { text: "Fix compilation of generated stub C files with int64 parameters", fix: true, oc: true },
        { text: "Move ExitProcess implementation from KERNEL32 to NTDLL", oc: true },
        { text: "Move ExitThread implementation from KERNEL32 to NTDLL", oc: true },
      ]
    })
  }
</script>

<style>
.v-timeline-item .v-list__tile__title
{
  height: auto;
}
</style>
